<app-journey-navigation
  [back]="true"
  [navigationDetails]="navigationDetails$ | async">
</app-journey-navigation>
<app-feature-wrapper
  [panelConfig]="panelConfig$ | async"
  [policyId]="policyId$ | async"
  [isProgressing]="isShowProgressBar$ | async"
  [policyChangeDate]="policyChangeDate$ | async"
  [journeyPath]="journeyPath$ | async"
  [vehicle]="vehicle$ | async"
  [selectedPolicyChange]="selectedPolicyChange$ | async">
</app-feature-wrapper>
<app-journey-navigation
  [navigationDetails]="navigationDetails$ | async">
</app-journey-navigation>
